import React, {useEffect} from "react";
import {useAuthContext} from "../../contexts/AuthContext";
import {AppSidebarNav} from "./AppSidebarNav";
import {Outlet} from "react-router-dom";

import {Navigate, useLocation} from "react-router";
import Box from "@mui/material/Box";
import {useUserContext} from "../../contexts/UserContext";
import './HomePage.scss'
import useDidMountEffect from "../../hooks/useDidMountEffect";

import { useMediaQuery } from 'react-responsive'
import {useUIContext} from "../../contexts/UIContext";
import {AppMobileNav} from "./AppMobileNav";
import Stack from "@mui/material/Stack";
import {useModalsStore} from "../../stores/modalsStore";
import {useShallow} from "zustand/react/shallow";
import {useInterval} from "../../hooks/useInterval";
import {useFetchHook} from "../../hooks/useFetchHook";
import fetcher from "../../fetcher";

export const mediaQueryForMobile = '(max-width: 1224px)'

export const HomePage = () => {
    const { isAuthenticated } = useAuthContext()
    const { updateProfile, profileState } = useUserContext()
    const { uiState } = useUIContext()
    let location = useLocation();
    const [checkVersionResponse, checkVersion] = useFetchHook(fetcher.checkVersion)

    const isTabletOrMobile = useMediaQuery({ query: mediaQueryForMobile })

    useDidMountEffect(function updatePagesVisited(){
        const pagesVisited = profileState?.pages_visited
        if (pagesVisited) {
            const pageVisited = location.pathname
            const lastPageVisited = pagesVisited[0]
            if (pageVisited !== lastPageVisited) {
                let newPagesVisited = structuredClone(profileState.pages_visited)
                newPagesVisited.unshift(pageVisited)
                newPagesVisited = newPagesVisited.slice(0,20)
                updateProfile({...profileState, pages_visited: newPagesVisited})
            }
        }
    }, [location]);

    useInterval(function checkClientVersion(){
        if (process.env.REACT_APP_ENV !== 'local') {
            checkVersion()
        }
    }, 300000)

    useDidMountEffect(function refreshBrowserIfVersionChanged(){
        if (checkVersionResponse?.data?.data && !checkVersionResponse.loading && !checkVersionResponse.error) {
            const currentVersion = checkVersionResponse?.data?.data.version
            const browserVersion = process.env.REACT_APP_VERSION

            if (String(currentVersion) !== String(browserVersion)) {
                window.location.reload(true)
            }
        }
    }, [checkVersionResponse])

    const {
        modals,
        closeModal,
    } = useModalsStore(
        useShallow((state) => ({
            modals: state.modals,
            closeModal: state.closeModal,
        }))
    )

    if (!isAuthenticated) {
        return <Navigate to={'/login'} replace={true}/>
    }

    const {sideNavDrawerWidth} = uiState

    const isStaging = process.env.REACT_APP_ENV === 'staging'

    return (
        <div
            style={{ flexDirection: isTabletOrMobile ? 'column' : 'row'}}
            id={"HomePage"}
        >
            {
                isStaging &&
                <Stack
                    direction="column"
                    justifyContent="center"
                    alignItems="center"
                    className={'staging-warning'}
                >
                    <span>Welcome to Staging where nothing matters</span>
                </Stack>
            }
            <Box
                style={{
                    width: isTabletOrMobile ? '100%' : `${sideNavDrawerWidth}px`
                }}
            >
                {
                    isTabletOrMobile ? <AppMobileNav/> : <AppSidebarNav />
                }
            </Box>
            <Box
                component="main"
                style={{
                    flexGrow: 1,
                    width: isTabletOrMobile ? '100%' : `calc(100% - ${sideNavDrawerWidth}px)`,
                    marginTop: isTabletOrMobile ? '56px' : '',
                }}
            >
                <Outlet/>
            </Box>

            {
                modals.map((modal, index) => {
                    const { element, props } = modal

                    return React.createElement(
                        element,
                        {
                            ...props,
                            key: index,
                            index,
                            open: true,
                            isOpen: true,
                            setIsOpen: () => closeModal(index)
                        },
                        null,
                        index
                    )
                })
            }
        </div>
    )
}
